export default __webpack_public_path__ + "static/media/m-slide-1-ori.1e283fbb.png";